export default [
  { name: 'Session', prop: 'session_id', type: 'autocomplete', references: 'admin/sessions', referenceProp: 'name', displayProp: 'long_name' },
  {
    name: 'Page',
    prop: 'page_id',
    type: 'autocomplete',
    references: 'admin/pages',
    referenceProp: 'name',
    displayProp: 'title',
    customFilters: { has_restricted_access: true }
  },
  { name: 'User', prop: 'user_id', type: 'autocomplete', references: 'admin/users', referenceProp: 'fullname', displayProp: 'name' }
]
